import { authRoleAccess } from 'auth/AuthRoleAccess'
import { lazy } from 'react'

const CaseTransferApprovals = lazy(() => import('./CaseTransferApprovals.jsx'))
const CaseDetails = lazy(() => import('../CaseClosureApprovals/CaseDetails.jsx'))

const CaseTransferApprovalsRoutes = [
  {
    path: '/transfer-approvals',
    component: CaseTransferApprovals,
    auth: authRoleAccess.transfer_approvals,
  },
  {
    path: '/transfer-approvals/case/:id',
    component: CaseDetails,
    auth: authRoleAccess.transfer_approvals,
  },
]

export default CaseTransferApprovalsRoutes